.checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 9px;
  cursor: pointer;
  border-radius: 50%;
  color: var(--tuna-palette-text-secondary);
  background: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color var(--tuna-transitions-duration-shortest) var(--tuna-transitions-easing-easeInOut);
}

.checkbox:hover {
  background-color: var(--tuna-palette-action-hover);
}

.checkbox:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.checkbox[data-checked],
.checked {
  color: var(--tuna-palette-primary-main);
}

.checkbox[data-checked] .unchecked,
.checkbox[data-indeterminate] .unchecked {
  display: none;
}

.checkbox:not([data-checked]):not([data-indeterminate]) .indicator {
  display: none;
}

.checkbox[data-disabled],
.checkbox:disabled {
  color: var(--tuna-palette-action-disabled);
  pointer-events: none;
  cursor: default;
}
